module.exports = __webpack_public_path__ + "fonts/light.e543081e.woff";